import React, { Fragment, useEffect, useState } from "react";
import PageTitle from "../../../layouts/PageTitle";
import * as Yup from "yup";
import CustomInput from "../../../Custom/CustomInput";
import { Field, FormikProvider, useFormik } from "formik";
import { Form, Label } from "reactstrap";
import CustomSelect from "../../../Custom/CustomSelect";
import { Row, Col, Accordion } from "react-bootstrap";
import CustomFlatpickr from "../../../Custom/CustomFlatpicker";
import { useHistory } from "react-router-dom";
import { get, post } from "../../../Helper/api_helper";
import {
  GET_CompanyDropDownList,
  POST_GetServicePriceListStaffWiseDetailByCompanyID,
  POST_ServicePriceListStaffWiseDetailSave,
  // POST_GetServiceMappingAndPriceListDetailByCompanyID,
  // POST_ServiceMappingAndPriceListDetailSave,
} from "../../../Helper/url_helper";
import { Spin } from "antd";
import { t } from "i18next";
import swal from "sweetalert";
import moment from "moment";

const ServicePriceList = () => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const [activeDefault, setActiveDefault] = useState(0);

  const [companyOptions, setCompanyOptions] = useState([]);

  const loadCompanyDDL = async () => {
    await get(GET_CompanyDropDownList)
      .then((res) => {
        if (res.IsSuccess) {
          setCompanyOptions(
            res.CompanyDDLList.map((item) => ({
              label: item.CompanyName,
              value: item.CompanyIDEncrypt,
            }))
          );
        }
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    loadCompanyDDL();
  }, []);

  const validationSchema = Yup.object().shape({
    CompanyID: Yup.string().required("Company is required field"),
    StaffCategoryID: Yup.string().required("Staff Category is required field"),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      CompanyID: "",
      StaffCategoryID: "",
      CurrentEffectiveDate: new Date(),
      NextEffectiveDate: "",
      CurrentEffectivePriceList: [],
      NextEffectivePriceList: [],
      SearchStaffCurrent: "",
      SearchStaffNext: "",
      SearchServiceCurrent: "",
      SearchServiceNext: "",
      IncreaseDecreaseByPercentageCurrent: "",
      IncreaseDecreaseByPercentageNext: "",
      PercentageCurrent: "",
      PercentageNext: "",
    },
    validateOnBlur: false,
  });

  const {
    setFieldValue,
    setValues,
    values: {
      CompanyID,
      CurrentEffectivePriceList,
      NextEffectivePriceList,
      StaffCategoryID,
      SearchStaffCurrent,
      SearchStaffNext,
      SearchServiceCurrent,
      SearchServiceNext,
      IncreaseDecreaseByPercentageCurrent,
      IncreaseDecreaseByPercentageNext,
      PercentageCurrent,
      PercentageNext,
    },
  } = formik;

  //   const GetServiceMappingAndPriceListByCompanyID = async (companyID) => {
  //     setIsLoading(true);
  //     await post(POST_GetServiceMappingAndPriceListDetailByCompanyID, {
  //       CompanyIDEncrypted: companyID,
  //     })
  //       .then((response) => {
  //         if (response.IsSuccess) {
  //           setValues({
  //             CompanyID: companyID,
  //             CurrentEffectiveDate: new Date(response.CurrentEffectiveDate),
  //             CurrentEffectivePriceList: [...response.CurrentEffectivePriceList],
  //             NextEffectiveDate: response.NextEffectiveDate ? new Date(response.NextEffectiveDate) : "",
  //             NextEffectivePriceList: [...response.NextEffectivePriceList],
  //           });
  //           setIsLoading(false);
  //         } else {
  //           swal("Error!", t(response.MessageCode), "error");
  //           setIsLoading(false);
  //         }
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //         setIsLoading(false);
  //       });
  //   };

  //   useEffect(() => {
  //     if (CompanyID) {
  //       GetServiceMappingAndPriceListByCompanyID(CompanyID);
  //     } else {
  //       formik.resetForm();
  //     }
  //   }, [CompanyID]);

  // const handleValidSubmit = (values) => {
  //   if (
  //     CurrentEffectivePriceList.filter((x) => x.IsSelected).filter(
  //       (x) => x.ServicePrice === ""
  //     ).length > 0
  //   ) {
  //     swal(
  //       "",
  //       "Current Effective: Selected Service Price is required!",
  //       "warning"
  //     );
  //     return;
  //   } else if (values.NextEffectiveDate) {
  //     if (
  //       NextEffectivePriceList.filter((x) => x.IsSelected).filter(
  //         (x) => x.ServicePrice === ""
  //       ).length > 0
  //     ) {
  //       swal(
  //         "",
  //         " Next Effective: Selected Service Price is required!",
  //         "warning"
  //       );
  //       return;
  //     }
  //   }
  //   setIsLoading(true);
  //   var Payload = {
  //     CompanyIDEncrypted: values.CompanyID,
  //     CurrentEffectiveDate: `${moment(values.CurrentEffectiveDate).format(
  //       "YYYY-MM-DD"
  //     ).replace(/^\-/, "")} 00:00:00.000`,
  //     NextEffectiveDate: values.NextEffectiveDate
  //       ? `${moment(values.NextEffectiveDate).format(
  //           "YYYY-MM-DD"
  //         ).replace(/^\-/, "")} 00:00:00.000`
  //       : "",
  //     CurrentEffectivePriceList: CurrentEffectivePriceList.filter(
  //       (x) => x.IsSelected
  //     ),
  //     NextEffectivePriceList: NextEffectivePriceList.filter(
  //       (x) => x.IsSelected
  //     ),
  //     LoginIDEncrypted: AuthUser?.LoginIDEncrypt,
  //   };
  //   post(POST_ServiceMappingAndPriceListDetailSave, Payload)
  //     .then((response) => {
  //       if (response.IsSuccess) {
  //         swal("Success!", t(response.MessageCode), "success");
  //       } else {
  //         swal("Error!", t(response.MessageCode), "error");
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false);
  //     });
  // };

  const optionsPercentage = [
    { label: "Increase", value: 1 },
    { label: "Decrease", value: 2 },
  ];

  const optionsStaffCategory = [
    { label: "L1", value: 1 },
    { label: "L2", value: 2 },
    { label: "L3", value: 3 },
  ];

  const GetServicePriceListStaffWiseDetailByCompanyID = async (
    companyID,
    staffCategoryID
  ) => {
    setIsLoading(true);
    await post(POST_GetServicePriceListStaffWiseDetailByCompanyID, {
      CompanyIDEncrypted: companyID,
      StaffCategoryID: staffCategoryID,
    })
      .then((response) => {
        if (response.IsSuccess) {
          setValues({
            CompanyID: companyID,
            StaffCategoryID: staffCategoryID,
            CurrentEffectiveDate: new Date(response.CurrentEffectiveDate),
            //CurrentEffectivePriceList: [...response.CurrentEffectivePriceList],
            CurrentEffectivePriceList: response.CurrentEffectivePriceList?.map(
              (x, i) => {
                return {
                  ...x,
                  show: true,
                  SalaryAmount:
                    parseFloat(x.SalaryAmount) === 0 ? "" : x.SalaryAmount,
                  PatientAmount:
                    parseFloat(x.PatientAmount) === 0 ? "" : x.PatientAmount,
                };
              }
            ),
            NextEffectiveDate: response.NextEffectiveDate
              ? new Date(response.NextEffectiveDate)
              : "",
            //NextEffectivePriceList: [...response.NextEffectivePriceList],
            NextEffectivePriceList: response.NextEffectivePriceList?.map(
              (x, i) => {
                return {
                  ...x,
                  show: true,
                  SalaryAmount:
                    parseFloat(x.SalaryAmount) === 0 ? "" : x.SalaryAmount,
                  PatientAmount:
                    parseFloat(x.PatientAmount) === 0 ? "" : x.PatientAmount,
                };
              }
            ),
            SearchStaffCurrent: "",
            SearchStaffNext: "",
            SearchServiceCurrent: "",
            SearchServiceNext: "",
            IncreaseDecreaseByPercentageCurrent: "",
            IncreaseDecreaseByPercentageNext: "",
            PercentageCurrent: "",
            PercentageNext: "",
          });
          setIsLoading(false);
        } else {
          swal("Error!", t(response.MessageCode), "error");
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (CompanyID && StaffCategoryID) {
      GetServicePriceListStaffWiseDetailByCompanyID(CompanyID, StaffCategoryID);
    } else {
      setValues({
        CompanyID: CompanyID,
        StaffCategoryID: StaffCategoryID,
        CurrentEffectiveDate: new Date(),
        CurrentEffectivePriceList: [],
        NextEffectiveDate: "",
        NextEffectivePriceList: [],
        SearchStaffCurrent: "",
        SearchStaffNext: "",
        SearchServiceCurrent: "",
        SearchServiceNext: "",
        IncreaseDecreaseByPercentageCurrent: "",
        IncreaseDecreaseByPercentageNext: "",
        PercentageCurrent: "",
        PercentageNext: "",
      });
    }
  }, [CompanyID, StaffCategoryID]);

  const handleValidSubmit = (values) => {
    if (
      CurrentEffectivePriceList.filter(
        (x) =>
          (x.SalaryAmount === "" && parseInt(x.SalaryType) !== 1) ||
          x.PatientAmount === ""
      ).length > 0
    ) {
      swal("", "Current Effective: Service Amount is required!", "warning");
      return;
    } else if (values.NextEffectiveDate) {
      if (
        NextEffectivePriceList.filter(
          (x) =>
            (x.SalaryAmount === "" && parseInt(x.SalaryType) !== 1) ||
            x.PatientAmount === ""
        ).length > 0
      ) {
        swal("", " Next Effective: Service Amount is required!", "warning");
        return;
      }
    }
    setIsLoading(true);
    var Payload = {
      CompanyIDEncrypted: values.CompanyID,
      StaffCategoryID: values.StaffCategoryID,
      CurrentEffectiveDate: `${moment(values.CurrentEffectiveDate)
        .format("YYYY-MM-DD")
        .replace(/^\-/, "")} 00:00:00.000`,
      NextEffectiveDate: values.NextEffectiveDate
        ? `${moment(values.NextEffectiveDate)
            .format("YYYY-MM-DD")
            .replace(/^\-/, "")} 00:00:00.000`
        : "",
      CurrentEffectivePriceList: CurrentEffectivePriceList.map((x) => {
        if (x.SalaryAmount === "") {
          return { ...x, SalaryAmount: "0" };
        } else {
          return { ...x };
        }
      }),
      NextEffectivePriceList: values.NextEffectiveDate
        ? NextEffectivePriceList.map((x) => {
            if (x.SalaryAmount === "") {
              return { ...x, SalaryAmount: "0" };
            } else {
              return { ...x };
            }
          })
        : [],
      LoginIDEncrypted: AuthUser?.LoginIDEncrypt,
    };
    post(POST_ServicePriceListStaffWiseDetailSave, Payload)
      .then((response) => {
        if (response.IsSuccess) {
          swal("Success!", t(response.MessageCode), "success");
        } else {
          swal("Error!", t(response.MessageCode), "error");
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    setFieldValue(
      "CurrentEffectivePriceList",
      CurrentEffectivePriceList?.map((x, i) => {
        return {
          ...x,
          show:
            SearchStaffCurrent &&
            SearchServiceCurrent &&
            x.StaffName?.toLowerCase().includes(
              SearchStaffCurrent?.toLowerCase()
            ) &&
            x.ServiceName?.toLowerCase().includes(
              SearchServiceCurrent?.toLowerCase()
            )
              ? true
              : SearchStaffCurrent &&
                !SearchServiceCurrent &&
                x.StaffName?.toLowerCase().includes(
                  SearchStaffCurrent?.toLowerCase()
                )
              ? true
              : !SearchStaffCurrent &&
                SearchServiceCurrent &&
                x.ServiceName?.toLowerCase().includes(
                  SearchServiceCurrent?.toLowerCase()
                )
              ? true
              : !SearchStaffCurrent && !SearchServiceCurrent
              ? true
              : false,
        };
      })
    );
  }, [SearchStaffCurrent, SearchServiceCurrent]);

  useEffect(() => {
    setFieldValue(
      "NextEffectivePriceList",
      NextEffectivePriceList?.map((x, i) => {
        return {
          ...x,
          show:
            SearchStaffNext &&
            SearchServiceNext &&
            x.StaffName?.toLowerCase().includes(
              SearchStaffNext?.toLowerCase()
            ) &&
            x.ServiceName?.toLowerCase().includes(
              SearchServiceNext?.toLowerCase()
            )
              ? true
              : SearchStaffNext &&
                !SearchServiceNext &&
                x.StaffName?.toLowerCase().includes(
                  SearchStaffNext?.toLowerCase()
                )
              ? true
              : !SearchStaffNext &&
                SearchServiceNext &&
                x.ServiceName?.toLowerCase().includes(
                  SearchServiceNext?.toLowerCase()
                )
              ? true
              : !SearchStaffNext && !SearchServiceNext
              ? true
              : false,
        };
      })
    );
  }, [SearchStaffNext, SearchServiceNext]);

  const IncreaseDecreasePriceCurrent = () => {
    if (IncreaseDecreaseByPercentageCurrent && PercentageCurrent) {
      swal({
        title: "Are you sure?",
        text: `Want to ${
          IncreaseDecreaseByPercentageCurrent === 1 ? "Increase" : "Decrease"
        } the Current Effective amount..`,
        icon: "warning",
        buttons: true,
        dangerMode: false,
      }).then((confirmResult) => {
        if (confirmResult) {
          if (IncreaseDecreaseByPercentageCurrent === 1) {
            setFieldValue(
              "CurrentEffectivePriceList",
              CurrentEffectivePriceList?.map((x) => {
                if (x.show) {
                  return {
                    ...x,
                    SalaryAmount: x.SalaryAmount
                      ? Math.round(
                          (parseInt(x.SalaryAmount) +
                            (x.SalaryAmount * PercentageCurrent) / 100) /
                            10
                        ) * 10
                      : "",
                    PatientAmount: x.PatientAmount
                      ? Math.round(
                          (parseInt(x.PatientAmount) +
                            (x.PatientAmount * PercentageCurrent) / 100) /
                            10
                        ) * 10
                      : "",
                  };
                } else {
                  return { ...x };
                }
              })
            );
          } else if (IncreaseDecreaseByPercentageCurrent === 2) {
            setFieldValue(
              "CurrentEffectivePriceList",
              CurrentEffectivePriceList?.map((x) => {
                if (x.show) {
                  return {
                    ...x,
                    SalaryAmount: x.SalaryAmount
                      ? Math.round(
                          (parseInt(x.SalaryAmount) -
                            (x.SalaryAmount * PercentageCurrent) / 100) /
                            10
                        ) * 10
                      : "",
                    PatientAmount: x.PatientAmount
                      ? Math.round(
                          (parseInt(x.PatientAmount) -
                            (x.PatientAmount * PercentageCurrent) / 100) /
                            10
                        ) * 10
                      : "",
                  };
                } else {
                  return { ...x };
                }
              })
            );
          }
        }
      });
    } else {
      if (!IncreaseDecreaseByPercentageCurrent) {
        swal({
          icon: "warning",
          text: "Select Increase or Decrease for changing the amount.",
          button: "OK",
        });
      } else {
        swal({
          icon: "warning",
          text: "Enter Percentage.",
          button: "OK",
        });
      }
    }
  };

  const IncreaseDecreasePriceNext = () => {
    if (IncreaseDecreaseByPercentageNext && PercentageNext) {
      swal({
        title: "Are you sure?",
        text: `Want to ${
          IncreaseDecreaseByPercentageNext === 1 ? "Increase" : "Decrease"
        } the Next Effective amount..`,
        icon: "warning",
        buttons: true,
        dangerMode: false,
      }).then((confirmResult) => {
        if (confirmResult) {
          if (IncreaseDecreaseByPercentageNext === 1) {
            setFieldValue(
              "NextEffectivePriceList",
              NextEffectivePriceList?.map((x) => {
                if (x.show) {
                  return {
                    ...x,
                    SalaryAmount: x.SalaryAmount
                      ? Math.round(
                          (parseInt(x.SalaryAmount) +
                            (x.SalaryAmount * PercentageNext) / 100) /
                            10
                        ) * 10
                      : "",
                    PatientAmount: x.PatientAmount
                      ? Math.round(
                          (parseInt(x.PatientAmount) +
                            (x.PatientAmount * PercentageNext) / 100) /
                            10
                        ) * 10
                      : x.PatientAmount,
                  };
                } else {
                  return { ...x };
                }
              })
            );
          } else if (IncreaseDecreaseByPercentageNext === 2) {
            setFieldValue(
              "NextEffectivePriceList",
              NextEffectivePriceList?.map((x) => {
                if (x.show) {
                  return {
                    ...x,
                    SalaryAmount: x.SalaryAmount
                      ? Math.round(
                          (parseInt(x.SalaryAmount) -
                            (x.SalaryAmount * PercentageNext) / 100) /
                            10
                        ) * 10
                      : "",
                    PatientAmount: x.PatientAmount
                      ? Math.round(
                          (parseInt(x.PatientAmount) -
                            (x.PatientAmount * PercentageNext) / 100) /
                            10
                        ) * 10
                      : "",
                  };
                } else {
                  return { ...x };
                }
              })
            );
          }
        }
      });
    } else {
      if (!IncreaseDecreaseByPercentageNext) {
        swal({
          icon: "warning",
          text: "Select Increase or Decrease for changing the amount.",
          button: "OK",
        });
      } else {
        swal({
          icon: "warning",
          text: "Enter Percentage.",
          button: "OK",
        });
      }
    }
  };

  return (
    <Fragment>
      <Spin size="large" spinning={isLoading} tip={"Loading..."}>
        <PageTitle activeMenu="Service Price List" motherMenu="Mapping" />

        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <FormikProvider value={formik}>
                  <Form onSubmit={formik.handleSubmit}>
                    <Row>
                      <Col lg={3}>
                        <Field
                          label={"Company"}
                          name="CompanyID"
                          placeholder={"Select Company"}
                          options={companyOptions}
                          component={CustomSelect}
                          required
                        />
                      </Col>
                      <Col lg={3}>
                        <Field
                          label={"Staff Category"}
                          name="StaffCategoryID"
                          placeholder={"Select Staff Category"}
                          options={optionsStaffCategory}
                          component={CustomSelect}
                          required
                        />
                      </Col>
                    </Row>

                    <hr></hr>
                    <Row>
                      <Col lg={12}>
                        <Accordion
                          className="accordion accordion-no-gutter accordion-header-bg"
                          defaultActiveKey={1}
                        >
                          <div className="accordion__item" key={1}>
                            <Accordion.Toggle
                              eventKey={1}
                              className={`accordion__header  ${
                                activeDefault === 1 ? "" : "collapsed"
                              }`}
                              style={{
                                minWidth: "100%",
                              }}
                              onClick={() =>
                                setActiveDefault(activeDefault === 1 ? -1 : 1)
                              }
                            >
                              <span
                                className="accordion__header--text"
                                style={{ float: "left" }}
                              >
                                {"Current Effective"}
                              </span>
                              <span className="accordion__header--indicator"></span>
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={1}>
                              <div className="accordion__body--text">
                                <Row>
                                  <Col lg={3}>
                                    <Field
                                      label={"Current Effective Date"}
                                      name="CurrentEffectiveDate"
                                      placeholder={
                                        "Select Current Effective Date"
                                      }
                                      component={CustomFlatpickr}
                                      options={{
                                        maxDate: new Date(),
                                        altInput: true,
                                        altFormat: "j-M-Y",
                                        dateFormat: "d-m-Y",
                                      }}
                                      disabled
                                    />
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg={3}>
                                    <Field
                                      label="Search Staff"
                                      type="text"
                                      name={"SearchStaffCurrent"}
                                      component={CustomInput}
                                      placeholder="Search here..."
                                    />
                                  </Col>
                                  <Col lg={3}>
                                    <Field
                                      label="Search Service"
                                      type="text"
                                      name={"SearchServiceCurrent"}
                                      component={CustomInput}
                                      placeholder="Search here..."
                                    />
                                  </Col>
                                  <Col lg={1}></Col>
                                  <Col lg={2}>
                                    <Field
                                      label="Increase/Decrease"
                                      name={
                                        "IncreaseDecreaseByPercentageCurrent"
                                      }
                                      component={CustomSelect}
                                      options={optionsPercentage}
                                      isClearable={false}
                                    />
                                  </Col>
                                  <Col lg={2}>
                                    <Field
                                      label="Percentage"
                                      type="number"
                                      name={"PercentageCurrent"}
                                      component={CustomInput}
                                      placeholder="Enter %"
                                      min={0}
                                      onChange={(e) => {
                                        if (e.target.value <= 100) {
                                          setFieldValue(
                                            "PercentageCurrent",
                                            e.target.value.slice(0, 3)
                                          );
                                        }
                                      }}
                                    />
                                  </Col>
                                  <Col lg={1}>
                                    <button
                                      type="button"
                                      className="btn mr-2 btn-xs btn-primary"
                                      style={{ marginTop: "28px" }}
                                      onClick={IncreaseDecreasePriceCurrent}
                                    >
                                      OK
                                    </button>
                                  </Col>
                                </Row>
                                <Row className="mt-2">
                                  <Col lg={12}>
                                    <div className="table-responsive ">
                                      <div className="dataTables_wrapper no-footer">
                                        <table
                                          className="table verticle-middle table-responsive-md mb-3"
                                          style={{ width: "100%" }}
                                        >
                                          <thead className="thead-light">
                                            <tr role="row">
                                              <th
                                                className="sorting"
                                                tabIndex={0}
                                                aria-controls="example5"
                                                rowSpan={1}
                                                colSpan={1}
                                                aria-label="StaffName: activate to sort column ascending"
                                                style={{
                                                  width: "22%",
                                                  padding: "10px 30px",
                                                }}
                                              >
                                                Staff Name
                                              </th>
                                              <th
                                                className="sorting"
                                                tabIndex={0}
                                                aria-controls="example5"
                                                rowSpan={1}
                                                colSpan={1}
                                                aria-label="ServiceName: activate to sort column ascending"
                                                style={{
                                                  width: "24%",
                                                  padding: "10px 30px",
                                                }}
                                              >
                                                Service Name
                                              </th>
                                              <th
                                                className="sorting"
                                                tabIndex={0}
                                                aria-controls="example5"
                                                rowSpan={1}
                                                colSpan={1}
                                                aria-label="Charge Type: activate to sort column ascending"
                                                style={{
                                                  width: "20%",
                                                  padding: "10px 30px",
                                                }}
                                              >
                                                Charge Type
                                              </th>
                                              <th
                                                className="sorting"
                                                tabIndex={0}
                                                aria-controls="example5"
                                                rowSpan={1}
                                                colSpan={1}
                                                aria-label="SalaryAmt: activate to sort column ascending"
                                                style={{
                                                  width: "17%",
                                                  padding: "10px 30px",
                                                }}
                                              >
                                                Salary Amt
                                              </th>
                                              <th
                                                className="sorting"
                                                tabIndex={0}
                                                aria-controls="example5"
                                                rowSpan={1}
                                                colSpan={1}
                                                aria-label="PatientAmt: activate to sort column ascending"
                                                style={{
                                                  width: "17%",
                                                  padding: "10px 30px",
                                                }}
                                              >
                                                Patient Amt
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {CurrentEffectivePriceList?.length >
                                            0 ? (
                                              CurrentEffectivePriceList?.map(
                                                (currentList, index) => (
                                                  <tr
                                                    role="row"
                                                    style={{
                                                      display: currentList.show
                                                        ? ""
                                                        : "none",
                                                    }}
                                                  >
                                                    <td>
                                                      {currentList.StaffName}
                                                    </td>
                                                    <td>
                                                      {currentList.ServiceName}
                                                    </td>
                                                    <td>
                                                      {currentList.ChargeType}
                                                    </td>
                                                    <td>
                                                      <Field
                                                        type="number"
                                                        name={`CurrentEffectivePriceList.[${index}].SalaryAmount`}
                                                        component={CustomInput}
                                                        //placeholder="Amount"
                                                        placeholder={
                                                          parseInt(
                                                            currentList.SalaryType
                                                          ) !== 1
                                                            ? "Amount"
                                                            : ""
                                                        }
                                                        onChange={(e) => {
                                                          setFieldValue(
                                                            `CurrentEffectivePriceList.[${index}].SalaryAmount`,
                                                            e.target.value.slice(
                                                              0,
                                                              6
                                                            )
                                                          );
                                                        }}
                                                        min={0}
                                                        disabled={
                                                          parseInt(
                                                            currentList.SalaryType
                                                          ) !== 1
                                                            ? false
                                                            : true
                                                        }
                                                      />
                                                    </td>
                                                    <td>
                                                      <Field
                                                        type="number"
                                                        name={`CurrentEffectivePriceList.[${index}].PatientAmount`}
                                                        component={CustomInput}
                                                        placeholder="Amount"
                                                        onChange={(e) => {
                                                          setFieldValue(
                                                            `CurrentEffectivePriceList.[${index}].PatientAmount`,
                                                            e.target.value.slice(
                                                              0,
                                                              6
                                                            )
                                                          );
                                                        }}
                                                        min={0}
                                                      />
                                                    </td>
                                                  </tr>
                                                )
                                              )
                                            ) : (
                                              <tr>
                                                <td colSpan={5}>
                                                  <div className="mt-2 ml-3 mb-3">
                                                    {"No Record Found"}
                                                  </div>
                                                </td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            </Accordion.Collapse>
                          </div>
                          <div className="accordion__item" key={2}>
                            <Accordion.Toggle
                              eventKey={2}
                              className={`accordion__header ${
                                activeDefault === 2 ? "" : "collapsed"
                              }`}
                              style={{
                                minWidth: "100%",
                                backgroundColor: "#d1d1d1",
                              }}
                              onClick={() =>
                                setActiveDefault(activeDefault === 2 ? -1 : 2)
                              }
                            >
                              <span
                                className="accordion__header--text"
                                style={{
                                  float: "left",
                                }}
                              >
                                {"Next Effective"}
                              </span>
                              <span className="accordion__header--indicator"></span>
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={2}>
                              <div className="accordion__body--text">
                                <Row>
                                  <Col lg={3}>
                                    <Field
                                      label={"Next Effective Date"}
                                      name="NextEffectiveDate"
                                      placeholder={"Select Next Effective Date"}
                                      component={CustomFlatpickr}
                                      options={{
                                        minDate: new Date(),
                                        altInput: true,
                                        altFormat: "j-M-Y",
                                        dateFormat: "d-m-Y",
                                      }}
                                    />
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg={3}>
                                    <Field
                                      label="Search Staff"
                                      type="text"
                                      name={"SearchStaffNext"}
                                      component={CustomInput}
                                      placeholder="Search Staff"
                                    />
                                  </Col>
                                  <Col lg={3}>
                                    <Field
                                      label="Search Service"
                                      type="text"
                                      name={"SearchServiceNext"}
                                      component={CustomInput}
                                      placeholder="Search Service"
                                    />
                                  </Col>
                                  <Col lg={1}></Col>
                                  <Col lg={2}>
                                    <Field
                                      label="Increase/Decrease"
                                      name={"IncreaseDecreaseByPercentageNext"}
                                      component={CustomSelect}
                                      options={optionsPercentage}
                                      isClearable={false}
                                    />
                                  </Col>
                                  <Col lg={2}>
                                    <Field
                                      label="Percentage"
                                      type="number"
                                      name={"PercentageNext"}
                                      component={CustomInput}
                                      placeholder="Enter %"
                                      min={0}
                                      onChange={(e) => {
                                        if (e.target.value <= 100) {
                                          setFieldValue(
                                            "PercentageNext",
                                            e.target.value.slice(0, 3)
                                          );
                                        }
                                      }}
                                    />
                                  </Col>
                                  <Col lg={1}>
                                    <button
                                      type="button"
                                      className="btn mr-2 btn-xs btn-primary"
                                      style={{ marginTop: "28px" }}
                                      onClick={IncreaseDecreasePriceNext}
                                    >
                                      OK
                                    </button>
                                  </Col>
                                </Row>
                                <Row className="mt-2">
                                  <Col lg={12}>
                                    <div className="table-responsive ">
                                      <div className="dataTables_wrapper no-footer">
                                        <table
                                          className="table verticle-middle table-responsive-md mb-3"
                                          style={{ width: "100%" }}
                                        >
                                          <thead className="thead-light">
                                            <tr role="row">
                                              <th
                                                className="sorting"
                                                tabIndex={0}
                                                aria-controls="example5"
                                                rowSpan={1}
                                                colSpan={1}
                                                aria-label="StaffName: activate to sort column ascending"
                                                style={{
                                                  width: "22%",
                                                  padding: "10px 30px",
                                                }}
                                              >
                                                Staff Name
                                              </th>
                                              <th
                                                className="sorting"
                                                tabIndex={0}
                                                aria-controls="example5"
                                                rowSpan={1}
                                                colSpan={1}
                                                aria-label="ServiceName: activate to sort column ascending"
                                                style={{
                                                  width: "24%",
                                                  padding: "10px 30px",
                                                }}
                                              >
                                                Service Name
                                              </th>
                                              <th
                                                className="sorting"
                                                tabIndex={0}
                                                aria-controls="example5"
                                                rowSpan={1}
                                                colSpan={1}
                                                aria-label="Charge Type: activate to sort column ascending"
                                                style={{
                                                  width: "20%",
                                                  padding: "10px 30px",
                                                }}
                                              >
                                                Charge Type
                                              </th>
                                              <th
                                                className="sorting"
                                                tabIndex={0}
                                                aria-controls="example5"
                                                rowSpan={1}
                                                colSpan={1}
                                                aria-label="SalaryAmt: activate to sort column ascending"
                                                style={{
                                                  width: "17%",
                                                  padding: "10px 30px",
                                                }}
                                              >
                                                Salary Amt
                                              </th>
                                              <th
                                                className="sorting"
                                                tabIndex={0}
                                                aria-controls="example5"
                                                rowSpan={1}
                                                colSpan={1}
                                                aria-label="PatientAmt: activate to sort column ascending"
                                                style={{
                                                  width: "17%",
                                                  padding: "10px 30px",
                                                }}
                                              >
                                                Patient Amt
                                              </th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {NextEffectivePriceList?.length >
                                            0 ? (
                                              NextEffectivePriceList?.map(
                                                (nextList, index) => (
                                                  <tr
                                                    role="row"
                                                    style={{
                                                      display: nextList.show
                                                        ? ""
                                                        : "none",
                                                    }}
                                                  >
                                                    <td>
                                                      {nextList.StaffName}
                                                    </td>
                                                    <td>
                                                      {nextList.ServiceName}
                                                    </td>
                                                    <td>
                                                      {nextList.ChargeType}
                                                    </td>
                                                    <td>
                                                      <Field
                                                        type="number"
                                                        name={`NextEffectivePriceList.[${index}].SalaryAmount`}
                                                        component={CustomInput}
                                                        //placeholder="Amount"
                                                        placeholder={
                                                          parseInt(
                                                            nextList.SalaryType
                                                          ) !== 1
                                                            ? "Amount"
                                                            : ""
                                                        }
                                                        onChange={(e) => {
                                                          setFieldValue(
                                                            `NextEffectivePriceList.[${index}].SalaryAmount`,
                                                            e.target.value.slice(
                                                              0,
                                                              6
                                                            )
                                                          );
                                                        }}
                                                        min={0}
                                                        disabled={
                                                          parseInt(
                                                            nextList.SalaryType
                                                          ) !== 1
                                                            ? false
                                                            : true
                                                        }
                                                      />
                                                    </td>
                                                    <td>
                                                      <Field
                                                        type="number"
                                                        name={`NextEffectivePriceList.[${index}].PatientAmount`}
                                                        component={CustomInput}
                                                        placeholder="Amount"
                                                        onChange={(e) => {
                                                          setFieldValue(
                                                            `NextEffectivePriceList.[${index}].PatientAmount`,
                                                            e.target.value.slice(
                                                              0,
                                                              6
                                                            )
                                                          );
                                                        }}
                                                        min={0}
                                                      />
                                                    </td>
                                                  </tr>
                                                )
                                              )
                                            ) : (
                                              <tr>
                                                <td colSpan={5}>
                                                  <div className="mt-2 ml-3 mb-3">
                                                    {"No Record Found"}
                                                  </div>
                                                </td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </Col>
                                </Row>{" "}
                              </div>
                            </Accordion.Collapse>
                          </div>
                        </Accordion>
                      </Col>
                    </Row>
                    <Row className="mt-4">
                      <Col lg={12}>
                        <button type="submit" className="btn mr-2 btn-primary">
                          Submit
                        </button>
                        <button
                          type="button"
                          className="btn mr-2 btn-light"
                          onClick={(e) => {
                            history.goBack();
                          }}
                        >
                          Cancel
                        </button>
                      </Col>
                    </Row>
                  </Form>
                </FormikProvider>
              </div>
            </div>
          </div>
        </div>
      </Spin>
    </Fragment>
  );
};

export default ServicePriceList;
